import { render, staticRenderFns } from "./VAdminProjectsPerformance.vue?vue&type=template&id=eafa8eb0&"
import script from "./VAdminProjectsPerformance.vue?vue&type=script&lang=js&"
export * from "./VAdminProjectsPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports